module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point02_03_winter-921dada627b5e80e9f3468c74202886f.jpg";